// extracted by mini-css-extract-plugin
module.exports = {"btnSuccess":"PlaceOrderButton_btnSuccess__26gdJ","btnSuccessDisabled":"PlaceOrderButton_btnSuccessDisabled__3rxp1"};